/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { VWBContext } from 'cio/utils/visual-workflow-builder/context';

interface VisualWorkflowBuilderEditActionSidebarExitEditorArgs {
  vwbContext: VWBContext;
}

export default class VisualWorkflowBuilderEditActionSidebarExitEditor extends Component<VisualWorkflowBuilderEditActionSidebarExitEditorArgs> {
  get zoomManager() {
    return this.args.vwbContext.zoomManager;
  }
}
